import {
  MdAssessment,
  MdHandshake,
  MdNoteAdd,
  MdOutlineAutoGraph,
  MdOutlinePeopleAlt,
  MdOutlineRequestQuote,
  MdOutlineSearch,
  MdOutlineTableView,
  MdOutlineTopic,
  MdPointOfSale,
  MdRefresh,
} from 'react-icons/md';
import { components } from '~/assets';
import Constants from '~/utils/constants';

// ATENÇÃO — divergência conhecida (2026-09-15): esta lista controla o que
// aparece no menu, mas src/routes/routeRoles.tsx é quem realmente bloqueia
// acesso a rota em privateRoute.tsx. As duas listas já divergiram (rotas
// aqui sem entrada correspondente lá, e papéis diferentes em rotas que
// existem nos dois lugares). Ver o mesmo aviso em routeRoles.tsx antes de
// mudar papéis de rota.
export const routesConfig = [
  {
    label: 'Dashboard B.I.',
    icon: <MdOutlineAutoGraph />,
    route: '/homeDash',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Home Dashboard',
        route: '/homeDash',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Fechamento Fatura',
        route: '/fechamentoFatura',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_OPERATOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Abertura de lojas',
        route: '/aberturaLoja',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Fat. sustentação',
        route: '/faturamentoSustentacao',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_OPERATOR,
        ],
      },
      {
        label: 'Disparos push',
        route: '/dashboard/push',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_OPERATOR,
        ],
      },
      {
        label: 'Propostas',
        route: '/dashDetailsProposal',
        roles: [],
      },
      {
        label: 'Base de Clientes',
        route: '/dashDetailsClientBase',
        roles: [],
      },
      {
        label: 'Benefícios',
        route: '/dashDetailsBenefitsRealTime',
        roles: [],
      },
      {
        label: 'Propostas',
        route: '/dashDetailsProposalRealTime',
        roles: [],
      },
      {
        label: 'Propostas',
        route: '/detailsColdRegistration',
        roles: [],
      },
      {
        label: 'Detalhes adesões',
        route: '/dashDetailsAdhesions',
        roles: [],
      },
      {
        label: 'Faturas Pagas',
        route: '/faturasPagas',
        roles: [],
      },
      {
        label: 'Histórico/Projeção',
        route: '/dashProjection',
        roles: [],
      },
      {
        label: 'Faturas em Atraso',
        route: '/faturasEmAtraso',
        roles: [],
      },
      {
        label: 'Créditos Disponíveis',
        route: '/creditosDisponiveis',
        roles: [],
      },
    ],
  },
  {
    label: 'Consulta Transação',
    icon: <MdOutlineRequestQuote />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
      // Constants.ROLE_RETAGUARDA,
    ],
    subMenu: [
      {
        label: 'Carteira Digital',
        route: '/consult-transaction/digital-wallet',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_LIDER_VENDAS,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Carteira Digital',
        route: '/consult-transaction/digital-wallet/detail',
        roles: [],
      },
      {
        label: 'Cartão Teucard',
        route: '/consult/transaction',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_LIDER_VENDAS,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Cartão Teucard',
        route: '/consult/transaction/detail',
        roles: [],
      },
      {
        label: 'Cartão Convênio',
        route: '/consult/transaction/agreement',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_LIDER_VENDAS,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Cartão Convênio',
        route: '/consult/transaction/agreement/detail',
        roles: [],
      },
    ],
  },

  {
    label: 'Consulta',
    icon: <MdOutlineSearch />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      // Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Cliente',
        route: '/consult/user',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_RETAGUARDA,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Cliente',
        route: '/consult/user/detail',
        roles: [],
      },
      {
        label: 'Histórico empréstimo',
        route: '/consult/user/history-loan',
        roles: [],
      },
      {
        label: 'Disputa',
        route: '/consult/dispute',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Biometria Facial',
        route: '/consult/user/biometrics',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
        ],
      },
      {
        label: 'Bometria Facial',
        route: '/consult/user/biometrics/detail',
        roles: [],
      },
      {
        label: 'Biometria Facial',
        route: '/consult/user/biometrics/unico/detail',
        roles: [],
      },
      {
        label: 'Biometria Facial',
        route: '/consult/user/biometrics/banknow/detail',
        roles: [],
      },
      {
        label: 'Biometria Facial Desbloqueio',
        route: '/consult/user/unlock-biometrics',
        roles: [],
      },
      {
        label: 'Disputa',
        route: '/consult/dispute/table',
        roles: [],
      },
      {
        label: 'Inclusão de Compra',
        route: '/consult/disable/detail',
        roles: [],
      },
    ],
  },
  {
    label: 'Mesa de Crédito',
    icon: <MdOutlineTableView />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_OPERATOR,
      // Constants.ROLE_RETAGUARDA,
      // Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Análise de Propostas',
        route: '/credit-table/proposal',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_OPERATOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Análise de Propostas',
        route: '/credit-table/proposal/detail',
        roles: [],
      },
      {
        label: 'Resumo da proposta',
        route: '/credit-table/proposal/proposal-resume',
        roles: [],
      },
      {
        label: 'Relatório',
        route: '/credit-table/report',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Relatório',
        route: '/credit-table/report/detail',
        roles: [],
      },
      {
        label: 'Reanálise de Limite - Solicitação',
        route: '/credit-table/limit/solicitation',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Reanálise de Limite - Solicitação',
        route: '/credit-table/limit/solicitation/detail',
        roles: [],
      },
      {
        label: 'Reanálise de Limite - Decisão',
        route: '/credit-table/limit/decision',
        roles: [Constants.ROLE_ADMIN],
      },
      {
        label: 'Reanálise de Limite - Decisão',
        route: '/credit-table/limit/decision/detail',
        roles: [],
      },
      {
        label: 'Reativar - Cliente',
        route: '/credit-table/reactivate/decision',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Reativar cliente',
        route: '/credit-table/reactivate/decision/detail',
        roles: [],
      },
    ],
  },
  {
    label: 'Fatura',
    icon: <MdOutlineTopic />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_ASSESSORIA,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_MESA_CREDITO,
      // Constants.ROLE_RETAGUARDA,
      // Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Consultar Fatura',
        route: '/invoice',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Consultar Fatura',
        route: '/invoice/detail',
        roles: [],
      },
      {
        label: 'Faturas futuras',
        route: '/invoice/detail/futureInvoices',
        roles: [],
        bread: [
          { to: '/invoice/detail', label: 'Fatura', goBack: true },
          {
            to: '/invoice/detail',
            label: 'Faturas futuras',
            disabled: true,
          },
        ],
      },
      {
        label: 'Extrato da fatura',
        route: '/invoice/detail/extract',
        roles: [],
        bread: [
          { to: '/invoice/detail', label: 'Fatura', goBack: true },
          {
            to: '/invoice/detail',
            label: 'Extrato',
            disabled: true,
          },
        ],
      },

      {
        label: 'Antecipação de financiamento',
        route: '/invoice/antecipation',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Antecipação de empréstimo',
        route: '/invoice/antecipation-loan',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Antecipação de Empréstimo',
        route: '/invoice/antecipation-loan/conference',
        roles: [],
        bread: [
          { to: '/invoice/antecipation-loan', label: 'Empréstimo' },
          {
            to: '/invoice/antecipation-loan',
            label: 'Antecipação de empréstimo',
            goBack: true,
          },
          {
            to: '/invoice/antecipation-loan/conference',
            label: 'Resumo',
            disabled: true,
          },
        ],
      },
      {
        label: 'Antecipação de compra',
        route: '/invoice/antecipation/purchase',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Antecipação de Financiamento',
        route: '/invoice/advance-financing/conference',
        roles: [],
        bread: [
          { to: '/invoice/antecipation', label: 'Fatura' },
          {
            to: '/invoice/antecipation',
            label: 'Antecipação de compra',
            goBack: true,
          },
          {
            to: '/invoice/advance-financing/conference',
            label: 'Resumo',
            disabled: true,
          },
        ],
      },
      {
        label: 'Antecipação de compra',
        route: '/invoice/antecipation/conference',
        roles: [],
        bread: [
          { to: '/invoice/antecipation/purchase', label: 'Fatura' },
          {
            to: '/invoice/antecipation/purchase',
            label: 'Antecipação de compra',
            goBack: true,
          },
          {
            to: '/invoice/antecipation/conference',
            label: 'Resumo',
            disabled: true,
          },
        ],
      },
      {
        label: 'Antecipação de compra',
        route: '/invoice/antecipation/purchase/history',
        roles: [],
      },
      {
        label: 'Antecipação de empréstimo',
        route: '/invoice/antecipation-loan/purchase/history',
        roles: [],
      },
      {
        label: 'Antecipação de compra',
        route: '/invoice/antecipation/payment',
        roles: [],
      },
      {
        label: 'Antecipação de Financiamento',
        route: '/invoice/advance-financing/payment',
        roles: [],
      },
      {
        label: 'Antecipação de Financiamento',
        route: '/invoice/advance-financing/history',
        roles: [],
      },
      {
        label: 'Inclusão de Transação',
        route: '/consult/disable',
        roles: [],
      },
      {
        label: 'Transação - Solicitação',
        route: '/invoice/purchase-inclusion',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
        ],
      },
      {
        label: 'Transação - Solicitação',
        route: '/invoice/purchase-inclusion/detail',
        roles: [],
      },
      {
        label: 'Transação - Decisão',
        route: '/invoice/purchase-decision',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Transação - Decisão',
        route: '/invoice/purchase-decision/detail',
        roles: [],
      },
      {
        label: 'Reprocessamento',
        route: '/invoice/reprocess',
        icon: <MdRefresh />,
        subMenu: [
          {
            label: 'Nova solicitação',
            route: '/invoice/reprocess/solicitation',

            roles: [
              Constants.ROLE_MESA_CREDITO,
              Constants.ROLE_ADMIN,
              Constants.ROLE_SUPERVISOR,
            ],
          },
          {
            label: 'Detalhes',
            route: '/invoice/reprocess/pending/details',
            roles: [],
          },
          {
            label: 'Pendentes',
            route: '/invoice/reprocess/pending',
            roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
          },

          {
            label: 'Histórico de reprocessamento',
            route: '/invoice/reprocess/historic',
            roles: [
              Constants.ROLE_ADMIN,
              Constants.ROLE_SUPERVISOR,
              Constants.ROLE_MESA_CREDITO,
            ],
          },
          {
            label: 'Detalhes',
            route: '/invoice/reprocess/historic/details',
            roles: [],
          },
        ],
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_MESA_CREDITO,
        ],
      },
    ],
  },
  {
    label: 'Negociação de dívidas',
    icon: <MdHandshake />,
    route: '',
    roles: [Constants.ROLE_MESA_CREDITO],
    subMenu: [
      {
        label: 'Buscar cliente',
        route: '/negociacao-dividas/buscar-cliente',
        roles: [Constants.ROLE_MESA_CREDITO],
      },
      {
        label: 'Detalhes',
        route: '/negociacao-dividas/cliente',
        roles: [],
        bread: [
          {
            to: '/negociacao-dividas/buscar-cliente',
            label: 'Negociação de dívidas',
          },
          {
            to: '/negociacao-dividas/buscar-cliente',
            label: 'Buscar cliente',
            goBack: true,
          },
          {
            to: '/negociacao-dividas/cliente',
            label: 'Detalhes',
            disabled: true,
          },
        ],
      },
      {
        label: 'Acordos Ativos',
        route: '/negociacao-dividas/acordos-ativos',
        roles: [Constants.ROLE_MESA_CREDITO],
      },
      {
        label: 'Detalhes',
        route: '/negociacao-dividas/acordos-ativos/detalhes',
        roles: [],
        bread: [
          {
            to: '/negociacao-dividas/acordos-ativos',
            label: 'Negociação de dívidas',
          },
          {
            to: '/negociacao-dividas/acordos-ativos',
            label: 'Acordos Ativos',
            goBack: true,
          },
          {
            to: '/negociacao-dividas/acordos-ativos/detalhes',
            label: 'Detalhes',
            disabled: true,
          },
        ],
      },
      {
        label: 'Histórico de negociações',
        route: '/negociacao-dividas/historico',
        roles: [Constants.ROLE_MESA_CREDITO],
      },
      {
        label: 'Detalhes',
        route: '/negociacao-dividas/historico/detalhes',
        roles: [],
        bread: [
          {
            to: '/negociacao-dividas/historico',
            label: 'Negociação de dívidas',
          },
          {
            to: '/negociacao-dividas/historico',
            label: 'Histórico de negociações',
            goBack: true,
          },
          {
            to: '/negociacao-dividas/historico/detalhes',
            label: 'Detalhes',
            disabled: true,
          },
        ],
      },
    ],
  },
  {
    label: 'Vendas',
    icon: <MdPointOfSale />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Vendas',
        route: '/sales',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_RETAGUARDA,
          Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Link de indicação',
        route: '/sales/indicationLink',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Cadastro de anfitrião',
        route: '/sales/indicationLinkCreate',
        roles: [],
      },
      {
        label: 'Detalhes do anfitrião',
        route: '/sales/indicationLinkEdit',
        roles: [],
      },
      {
        label: 'Meus Eventos',
        route: '/sales/eventCenter',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          Constants.ROLE_RETAGUARDA,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Solicitação de Evento',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/requestEvent',
        roles: [],
      },
      {
        label: 'Detalhes da Solicitação',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/SolicitationDetails',
        roles: [],
      },
      {
        label: 'Detalhes de lead conta',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/accountLead/details',
        roles: [],
      },
      {
        label: 'Downgrade',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/downgradeDecision',
        roles: [],
      },
      {
        label: 'Upgrade',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/upgradeDecision',
        roles: [],
      },
      {
        label: 'Solicitação de Lead',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/leadSolicitation',
        roles: [],
      },
      {
        label: 'Solicitação de Upgrade',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/upgradeSolicitation',
        roles: [],
      },
      {
        label: 'Decisão',
        icon: <MdPointOfSale />,
        route: '/sales/eventCenter/leadDecision',
        roles: [],
      },
    ],
  },
  {
    label: 'Parceiros',
    icon: <components.PosTerminal />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      // Constants.ROLE_RETAGUARDA,
    ],
    subMenu: [
      {
        label: 'Consulta',
        route: '/teu-pag/estabelecimento',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Parâmetros',
        route: '/teu-pag/parametros',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
      {
        label: 'Relatório',
        route: '/teu-pag/report',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_ASSESSORIA,
          Constants.ROLE_OPERATOR,
          Constants.ROLE_MESA_CREDITO,
          // Constants.ROLE_RETAGUARDA,
        ],
      },
    ],
  },
  {
    label: 'Parceiros',
    route: '/teu-pag/estabelecimento/detail',
    roles: [],
    bread: [
      { to: '/teu-pag/estabelecimento', label: 'Parceiros' },
      {
        to: '/teu-pag/estabelecimento',
        label: 'Consulta',
        goBack: true,
      },
      {
        to: '/teu-pag/estabelecimento/detail',
        label: 'Detalhes',
        disabled: true,
      },
    ],
  },
  {
    label: 'Acesso Portal',
    route: '/teu-pag/estabelecimento/detail/portalAccess',
    roles: [],
    bread: [
      { to: '/teu-pag/estabelecimento', label: 'Parceiros' },
      {
        to: '/teu-pag/estabelecimento',
        label: 'Consulta',
        goBack: true,
      },
      {
        to: '/teu-pag/estabelecimento/detail',
        label: 'Acesso Portal',
        disabled: true,
      },
    ],
  },
  {
    label: 'Vendas',
    icon: <MdPointOfSale />,
    route: '/sales/detail',
    roles: [],
  },
  {
    label: 'Usuário',
    icon: <MdOutlinePeopleAlt />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      // Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Auditoria',
        route: '/consult/audit',
        roles: [Constants.ROLE_ADMIN],
      },
      {
        label: 'Funcionário',
        route: '/consult/employee',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Cliente',
        route: '/consult/costumer',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
    ],
  },

  {
    label: 'Usuario',
    icon: <MdOutlinePeopleAlt />,
    route: '/consult/employee/register',
    roles: [],
    bread: [
      { to: '/consult/employee', label: 'Funcionário' },
      {
        to: '/consult/employee/register',
        label: 'Registrar',
        goBack: true,
      },
    ],
  },
  {
    label: 'Usuário',
    route: '/consult/employee/detail',
    roles: [],
    bread: [
      { to: '/consult/employee', label: 'Usuário' },
      { to: '/consult/employee', label: 'Funcionário', goBack: true },
      { to: '/consult/employee/detail', label: 'Detalhes', disabled: true },
    ],
  },
  {
    label: 'Histórico alt. senha',
    icon: <MdOutlinePeopleAlt />,
    route: '/consult/employee/passwordHistory/detail',
    roles: [],
    bread: [
      { to: '/consult/employee', label: 'Usuário' },
      { to: '/consult/employee', label: 'Funcionário' },
      { to: '/consult/employee/detail', label: 'Detalhes', goBack: true },
      {
        to: '/consult/employee/passwordHistory/detail',
        label: 'Histórico de alteração de senha',
        disabled: true,
      },
    ],
  },
  {
    label: 'Usuário',
    route: '/consult/costumer/detail',
    roles: [],
    bread: [
      { to: '/consult/costumer', label: 'Usuário' },
      { to: '/consult/costumer', label: 'Cliente', goBack: true },
      { to: '/consult/costumer/detail', label: 'Detalhes', disabled: true },
    ],
  },
  {
    label: 'Histórico de acesso',
    icon: <MdOutlinePeopleAlt />,
    route: '/consult/costumer/appAccess/detail',
    roles: [],
    bread: [
      { to: '/consult/costumer', label: 'Usuário' },
      { to: '/consult/costumer', label: 'Cliente', goBack: true },
      {
        to: '/consult/employee/detail',
        label: 'Histórico de acesso',
        disabled: true,
      },
    ],
  },
  {
    label: 'Histórico alt. senha',
    icon: <MdOutlinePeopleAlt />,
    route: '/consult/costumer/passwordHistory/detail',
    roles: [],
    bread: [
      { to: '/consult/costumer', label: 'Usuário' },
      { to: '/consult/costumer', label: 'Cliente' },
      { to: '/consult/costumer/detail', label: 'Detalhes', goBack: true },
      {
        to: '/consult/costumer/passwordHistory/detail',
        label: 'Histórico de alteração de senha',
        disabled: true,
      },
    ],
  },
  {
    label: 'Usuário',
    icon: <MdOutlinePeopleAlt />,
    route: '/consult/reactivate-user/detail',
    roles: [],
  },
  {
    label: 'Relatório',
    icon: <MdAssessment />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Benefícios',
        route: '/report/benefit',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Carteira Digital',
        route: '/report/wallet',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Faturas',
        route: '/report/invoice',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Financeiro',
        route: '/report/financial',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Proposta',
        route: '/report/proposal',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Cartões',
        route: '/report/card',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Emprestimos',
        route: '/report/loan',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Eventos',
        route: '/report/events',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Outros',
        route: '/report/others',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
    ],
  },
  {
    label: 'Arquivos',
    icon: <MdNoteAdd />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      // Constants.ROLE_LIDER_VENDAS,
    ],
    subMenu: [
      {
        label: 'Importação',
        route: '/file/upload',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Histórico',
        route: '/file/history',
        roles: [],
      },
      {
        label: 'Documentos',
        route: '/file/documents/history',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Nova solicitação',
        route: '/file/documents',
        roles: [],
        bread: [
          {
            label: 'Documentos',
            to: '/file/documents/history',
          },
        ],
      },
      {
        label: 'Detalhes',
        route: '/file/documents/detalhes',
        roles: [],
        bread: [
          {
            label: 'Documentos',
            to: '/file/documents/history',
          },
          {
            label: 'Nova solicitação',
            to: '/file/documents',
          },
        ],
      },
      {
        label: 'Cobrança',
        route: '/file/charge',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Positivados',
        route: '/file/positive',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Propostas',
        route: '/file/proposal',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          // Constants.ROLE_LIDER_VENDAS,
        ],
      },
      {
        label: 'Limites ativos',
        route: '/file/activeLimits',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Base de clientes',
        route: '/file/customer-base',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Contas a receber',
        route: '/file/invoice-file',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
      {
        label: 'Cancelamento Inatividade',
        route: '/file/cancel-inactivity',
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
      },
    ],
  },
  {
    label: 'Recursos',
    icon: <MdOutlineTableView />,
    route: '',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_OPERATOR,
    ],
    subMenu: [
      {
        label: 'Campanha',
        route: '/campanha',
        roles: [
          Constants.ROLE_ADMIN,
          Constants.ROLE_SUPERVISOR,
          Constants.ROLE_OPERATOR,
        ],
      },
      {
        label: 'Detalhes da campanha',
        route: '/lista-cliente-campanha',
        roles: [],
      },
      {
        label: 'Nova campanha',
        route: '/criar-campanha',
        roles: [],
      },
      {
        label: 'Nova campanha',
        route: '/communication',
        roles: [],
      },
      {
        label: 'Nova campanha - Preview',
        route: '/communication-preview',
        roles: [],
      },
      {
        label: 'Campanha - Gerar - Definir ações',
        route: '/define-communication-actions',
        roles: [],
      },
      {
        label: 'Produtos',
        route: '/management-tools/products',
        roles: [Constants.ROLE_ADMIN],
      },
      {
        route: '/management-tools/personalize-app-home',
        label: 'Personalizar home app',
        roles: [Constants.ROLE_ADMIN],
      },
      {
        label: 'IPs Autorizados',
        route: '/management-tools/authorized-ips',
        roles: [Constants.ROLE_ADMIN],
      },
      {
        label: 'Parâmetros Gerais',
        route: '/parameters/all',
        roles: [Constants.ROLE_ADMIN],
      },
    ],
  },
  {
    label: 'Eventos',
    route: '/parameters/events-center',
    roles: [],
    bread: [
      { to: '/parameters/all', label: 'Recursos', disabled: true },
      { to: '/parameters/all', label: 'Parâmetros Gerais', goBack: true },
      { to: '/parameters/events-center', label: 'Eventos' },
    ],
  },
];
